import { MsalProvider } from '@azure/msal-react'
import i18n, { initializeI18N } from '@if/core/i18n'
import { initializeTelemetry } from '@if/core/telemetry'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
import App from './containers/App/App'
import './index.css'
import { AppConfigProvider } from './providers/AppConfigProvider'
import PreferencesProvider from './providers/PreferencesProvider'
import UserProvider from './providers/UserProvider'
import msalInstance, { initializeMsal } from './services/Authentification'
import { reportErrorToConsole } from './services/error-logger'

initializeTelemetry({
  instrumentationKey: import.meta.env.VITE_APP_INSIGHT_INSTRUMENTAL_KEY,
  appName: 'backoffice',
  appVersion: import.meta.env.VITE_VERSION,
})

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
})
const container = document.getElementById('root')
const root = createRoot(container!)
Promise.all([initializeMsal(), initializeI18N()])
  .then(() => { 
    i18n.services.formatter?.add('lowercase', (value, _lng, _options) => `${value}`.toLowerCase())
  })
  .then(() => {
    root.render(
      <StrictMode>
        <Suspense fallback="loading">
          <QueryClientProvider client={queryClient}>
            <I18nextProvider i18n={i18n}>
              <PreferencesProvider>
                <MsalProvider instance={msalInstance}>
                  <UserProvider>
                    <AppConfigProvider>
                      <App />
                    </AppConfigProvider>
                  </UserProvider>
                </MsalProvider>
              </PreferencesProvider>
            </I18nextProvider>
          </QueryClientProvider>
        </Suspense>
      </StrictMode>,
    )
  })
  .catch(reportErrorToConsole)
